require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/modules/typeahead.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/modules/typeahead.legacy.js
// module id = 718
// module chunks = 31